import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { apiService } from '../../../services/apiService';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { getCountryCallingCode } from 'libphonenumber-js';
function ItRecruiterEdit() {
    const allowedCountries = ['US', 'IN', 'CA', 'DE', 'AU', 'GB', 'PK'];
    const maxPhoneLengths = { 
        US: 10,  // United States
        IN: 10,  // India
        CA: 10,  // Canada
        DE: 11,  // Germany
        AU: 9,   // Australia
        GB: 10,  // United Kingdom
        PK: 10   // Pakistan
    };
    const navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone_number: '',
        accuracy: '',
    });
    const [errors, setErrors] = useState({});
    const [btnloading, setBtnLoading] = useState(false);
    const [errorsmessage, setErrorMessage] = useState('');
    

    const fetchRecruiterData = useCallback(async () => {
        try {
            const response = await apiService.getRequest(`/c2c/recruiters/${id}`);
            const Recruiter = response?.data;
            setFormData({
                name: Recruiter?.name || '',
                email: Recruiter?.email || '',
                phone_number: Recruiter?.phone_number || '',
                accuracy: Recruiter?.accuracy || '',
                
            });
        } catch (error) {
            
        }finally {
            setLoading(false);
        }
    }, [id]);
    useEffect(() => {
        fetchRecruiterData();
    }, [fetchRecruiterData]);

    // Clear specific errors when inputs are modified
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        // Clear the error for the changed field
        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };
    

    const handlePhoneChange = (value, fieldName) => {
        if (value) {
            const country = allowedCountries.find(
            (c) => value.startsWith(`+${getCountryCallingCode(c)}`)
            ) || 'US';
    
            const maxLength = maxPhoneLengths[country];
    
            // Strip the country code and check the actual phone number length
            const phoneWithoutCode = value.replace(`+${getCountryCallingCode(country)}`, '').replace(/\D/g, '');
            
            if (phoneWithoutCode.length <= maxLength) {
            handleInputChange({ target: { name: fieldName, value } });
            }
        } else {
            handleInputChange({ target: { name: fieldName, value: '' } });
        }
    };
    const handleKeyDown = (event, fieldName) => {
        const { key } = event;
        const currentValue = formData[fieldName] || ''; // Use dynamic field name
        const country = allowedCountries.find(
            (c) => currentValue.startsWith(`+${getCountryCallingCode(c)}`)
        ) || 'US';

        const maxLength = maxPhoneLengths[country];

        // Remove country code and check the actual phone number length
        const phoneWithoutCode = currentValue.replace(`+${getCountryCallingCode(country)}`, '').replace(/\D/g, '');

        if (phoneWithoutCode.length >= maxLength && /\d/.test(key)) {
            event.preventDefault(); // Stop further input
        }
    };

    // Basic validation logic
    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Name is required';
        if (!formData.email) newErrors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email is invalid';
        if (!formData.phone_number) newErrors.phone_number = 'Phone number is required';

        if (!formData.accuracy) newErrors.accuracy = 'Accuracy is required';

        const email = formData.email;
        const emailFormat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailFormat.test(email)) {
            newErrors.email = 'Please enter a valid email address.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        const data = new FormData();
        data.append('name', formData.name);
        data.append('email', formData.email);
        data.append('phone_number', formData.phone_number);
        data.append('accuracy', formData.accuracy);

        setBtnLoading(true);
        try {
            const response = await apiService.postRequest(`/c2c/recruiters/${id}`, data);
            if (response && response.success === true) {
                navigate(`/recruiter/it/view/${id}`)
                toast(response.message || "Created successfully!");
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            // console.error('Error', error);
        } finally {
            setBtnLoading(false);
        }
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container justifyContent="center" className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>C2C</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/recruiter/it-recruiter")}>C2C</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/recruiter/it-recruiter")}>IT Recruiter</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Edit IT Recruiter</span>
                    </Grid>
                    <Grid size={{xs:12}} container className="editgrouphead my-4">
                        <h2>Edit IT Recruiter</h2>
                    </Grid>
                </Grid>
                {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                    <form className='row justify-content-center w-100'>
                        <Grid size={{sm:11,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Name<small className='red_starimpo'>*</small></span>
                                <input type="text" name="name" placeholder='Enter Name' value={formData.name} onChange={handleInputChange} onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}/>
                                {errors.name && <p style={{color:"red"}}>{errors.name}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Email Id<small className='red_starimpo'>*</small></span>
                                <input type="text" placeholder='example@gmail.com' name="email" value={formData.email} onChange={handleInputChange}/>
                                {errors.email && <p style={{color:"red"}}>{errors.email}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                <span className='mt-0'>Phone Number<small className='red_starimpo'>*</small></span>
                                <PhoneInput
                                    placeholder="Enter phone number"
                                    defaultCountry="US"
                                    countries={allowedCountries}
                                    international={false}
                                    limitMaxLength={true}
                                    value={formData.phone_number}
                                    onChange={(value) => handlePhoneChange(value, "phone_number")}
                                    onKeyDown={(e) => handleKeyDown(e, "phone_number")}
                                    autoComplete="new-password"
                                />
                                {errors.phone_number && <p style={{color:"red"}}>{errors.phone_number}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="regiter_inputs mb-4">
                                <span className='mt-0'>Accuracy<small className='red_starimpo'>*</small></span>
                                <select name="accuracy" value={formData.accuracy} onChange={handleInputChange}>
                                    <option value="">Select Accuracy</option>
                                    <option value="High">High</option>
                                    <option value="Medium">Medium</option>
                                    <option value="Low">Low</option>
                                </select>
                                {errors.accuracy && <p style={{color:"red"}}>{errors.accuracy}</p>}
                            </Grid>
                        {errorsmessage && <p style={{ color: 'red', width:"100%" }}>{errorsmessage}</p>}
                        </Grid>
                        <Grid size={{sm:11,xs:12}} container justifyContent="flex-end" className="gap-3 my-3">
                            <button type="button" className='registersendbtn1 my-0' onClick={()=>navigate(`/recruiter/it/view/${id}`)}>Cancel</button>
                            <button type="button" onClick={handleSubmit} className='registersendbtn2 my-0 px-3'>{btnloading ? <img src={require('../../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                        </Grid>
                    </form>
                </>}
            </Grid>
        </div>
    </div>
  )
}

export default ItRecruiterEdit
